/**
 * アコーディオン
 */

import gsap from "gsap";


/**
 * モバイルフルナビ用の変数、css追加
 */

// fullnav用のcssクラス、要素追加
const fullNavMainMenu = document.querySelector('.fullnav nav.maxtab-only ul#mainMenu');
const navList = document.querySelectorAll('.fullnav nav.maxtab-only ul#mainMenu > li')

fullNavMainMenu.classList.add('accordion');

navList.forEach((element) => {
  element.classList.add('accordion__item', 'fade-top');
  // element.appendChild(btnPlus);
})



/**
 * アコーディオン コード
 */

const accordion = () => {

  // アコーディオンコード
  const accItems = gsap.utils.toArray(".accordion__item");
  let openMenu;

  accItems.forEach(item => {
    let itemContainer = item.querySelector(".accordion__panel"),
      itemContent = item.querySelector(".accordion__content"),
      itemTab = item.querySelector(".accordion__button"),
      isOpen = false;

    gsap.set(itemContent, {
      autoAlpha: 0,
      y: 10
    });

    function setupTab() {
      itemTab.setAttribute("aria-expanded", "false");
      item.setAttribute("class", "accordion__item");
      itemContainer.setAttribute("aria-hidden", "true");
    }

    function setupActiveTab() {
      itemTab.setAttribute("aria-expanded", "true");
      item.setAttribute("class", "accordion__item selected");
      itemContainer.setAttribute("aria-hidden", "false");
    }

    item.open = () => {
      if (!isOpen) {
        isOpen = true;
        openMenu && openMenu.close();
        openMenu = item;

        const tl = gsap.timeline({
          defaults: {
            overwrite: true
          },
          onStart: () => {
            setupActiveTab();
          },
        });

        tl.to(itemContainer, {
            height: "auto",
            duration: 0.2,
            ease: "ease",
            overwrite: true
          })
          .to(itemContent, {
            overwrite: true,
            duration: 0.5,
            autoAlpha: 1,
            y: 0,
            ease: "ease",
          }, "<+=50%");
      }
    };

    item.close = () => {
      if (isOpen) {
        isOpen = false;
        openMenu = null;

        const tl = gsap.timeline({
          defaults: {
            overwrite: true
          },
          onStart: () => {
            setupTab();
          },
        });
        tl.to(itemContent, {
            overwrite: true,
            duration: 0.2,
            autoAlpha: 0,
            y: 10,
            ease: "ease",
          })
          .to(itemContainer, {
            height: 0,
            duration: 0.5,
            overwrite: true,
            onComplete: () =>
              gsap.set(itemContent, {
                autoAlpha: 0,
                y: 10,
                overwrite: true
              }),
          }, "<+=50%");
      }
    };
    //itemContainer[1] = menu.open();
    item.addEventListener("click", () => isOpen ? item.close() : item.open());

  });

}


export default accordion;

